var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpices(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m293.09 286.791c-4.741 18.966-8.52 38.162-11.359 57.495h223.966c-2.839-19.333-6.618-38.529-11.36-57.495-4.145-16.578-7.526-33.341-10.14-50.22h-180.966c-2.615 16.879-5.996 33.642-10.141 50.22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m281.433 0h224.563v68.857h-224.563z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m309.857 98.857h167.714v38.856h-167.714z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m307.04 206.571h173.348c-1.295-12.917-2.158-25.878-2.555-38.857h-168.238c-.397 12.979-1.26 25.94-2.555 38.857z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m509.331 374.286h-231.234c-1.769 18.6-2.669 37.283-2.669 55.976v81.738h236.572v-81.738c0-18.693-.9-37.376-2.669-55.976zm-150.056 92.059-21.191-21.191 21.213-21.213 21.191 21.191zm68.856 0-21.191-21.191 21.214-21.213 21.191 21.191z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.004 137.717h224.563v69.733h-224.563z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m202.143 277.762v-40.312h-167.714v40.312c-19.943 6.367-34.429 25.069-34.429 47.095v187.143h236.571v-187.143c0-22.026-14.485-40.728-34.428-47.095zm-118.275 60.322 21.191 21.19-21.213 21.213-21.191-21.19zm-.022 111.261-21.191-21.191 21.214-21.213 21.191 21.191zm68.858 0-21.191-21.191 21.213-21.213 21.191 21.191zm0-68.858-21.191-21.19 21.213-21.213 21.191 21.19z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpices);
export default __webpack_public_path__ + "static/media/spices.db2caf6a3c233cf186f39cf133f3f0eb.svg";
export { ForwardRef as ReactComponent };